import React from 'react';

/**
 * RenameSyncNote — the inline line under a rename field whose value is SHARED with another
 * screen. Owner ruling 2026-10-28 (review M-8): *"they match, renaming the job code renames the
 * gag, renaming the gag renames the job code. warnings on both to say this will update the name
 * in breakdown or this will update the name in the budget"*.
 *
 *   - under a gag's Title (Breakdown row + panel) when the gag has an ACTIVE job code
 *     (`has_job_code`, server-computed): `where="Budget"`;
 *   - under a LINKED job code's name (Cost Codes & Budget row + phone panel): `where="Breakdown"`.
 *
 * Quiet grey while the name is untouched; AMBER once the typed name differs from the saved one,
 * because that is the moment the save will reach the other screen. Plain text, no box, no icon:
 * a consequence, not an error. WHO may do it is the server's answer (a refusal names the missing
 * right: `gag_rename_needs_budget_rights` / `job_rename_needs_breakdown_rights`).
 */
export default function RenameSyncNote({ where, changed = false, testId }) {
  return (
    <p
      className={`mt-1 text-xs leading-snug ${changed ? 'text-amber-700 dark:text-amber-300' : 'text-gray-500 dark:text-gray-400'}`}
      data-testid={testId}
      data-changed={changed ? 'true' : 'false'}
    >
      This will also rename it in the {where}
    </p>
  );
}
